import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Workstation from './workstation';

@Model()
export default class WorkstationPatch extends ApplicationRecord {
    static jsonapiType = 'workstation_patches';
    @Attr() state: string;

    @BelongsTo() workstation: Workstation;
}
